import { memo } from 'react';
import { usePlaybackContext } from "../../../context/Playback";
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BlockedTimestamp = function BlockedTimestamp(_ref) {
  var visible = _ref.visible,
    hoveredTime = _ref.hoveredTime,
    progressWidth = _ref.progressWidth;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _usePlaybackContext = usePlaybackContext(),
    duration = _usePlaybackContext.duration;
  if (!Number.isFinite(duration) || duration <= 0) {
    return null;
  }
  var timestampWidth = 200;
  var hoveredProgress = hoveredTime / duration;
  var left = progressWidth * hoveredProgress - timestampWidth / 2;
  if (left < 0) {
    left = 0;
  } else if (left > progressWidth - timestampWidth) {
    left = progressWidth - timestampWidth;
  }
  var cursorPositionInTimestamp = progressWidth * hoveredProgress - left;
  var arrowLeft = '50%';

  // If timestamp is at the left edge, position arrow at cursor with 10px margin
  if (left === 0) {
    var arrowPosition = Math.max(5, Math.min(cursorPositionInTimestamp, timestampWidth - 5));
    arrowLeft = "".concat(arrowPosition, "px");
  }
  // If timestamp is at the right edge, position arrow at cursor with 10px margin
  else if (left === progressWidth - timestampWidth) {
    var _arrowPosition = Math.max(15, Math.min(cursorPositionInTimestamp, timestampWidth - 15));
    arrowLeft = "".concat(_arrowPosition, "px");
  }
  return /*#__PURE__*/_jsx("div", {
    className: "flex absolute z-1 pb-8 ".concat(visible ? 'cui-is-visible' : 'cui-is-hidden'),
    style: {
      width: "".concat(timestampWidth, "px"),
      left: "".concat(left, "px"),
      bottom: '10px'
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-items-center tw-justify-center tw-w-full tw-h-6.4 tw-text-center tw-px-1 tw-bg-primary-light-100 tw-rounded-0.8 tw-text-1.2 tw-leading-1.6 tw-relative",
      children: [t('BLOCKED_TIMESTAMP_LABEL'), /*#__PURE__*/_jsx("div", {
        className: "tw-absolute tw-bottom-[-4px] tw-w-0 tw-h-0",
        style: {
          left: arrowLeft,
          transform: arrowLeft === '50%' ? 'translateX(-50%)' : 'none',
          borderLeft: '4px solid transparent',
          borderRight: '4px solid transparent',
          borderTop: '4px solid #f3f4f6'
        }
      })]
    })
  });
};
export default /*#__PURE__*/memo(BlockedTimestamp);